import React from 'react'
import { Card } from "react-bootstrap"
import { MdAccessTime } from "react-icons/md";
import { AiOutlineCalendar } from "react-icons/ai";
import { withTranslation } from 'react-i18next';

const CardHistorialCitas = ({t, item}) => {
    const { scheduleDTO, medicalHistoryDTO } = item

    return (
        <>
            <Card className="shadow-1 formSection doctor-informacion">
                <div className='body'>
                    <span className='historical-text-primary'>
                        <AiOutlineCalendar /> {scheduleDTO?.date}
                    </span> &nbsp; &nbsp;
                    <span className='historical-text-primary'>
                        <MdAccessTime /> {scheduleDTO?.hour} 
                    </span>
                    <br/><br/>

                    {
                        medicalHistoryDTO?.questionsDTOList != null && medicalHistoryDTO?.questionsDTOList.length > 0
                        ? medicalHistoryDTO?.questionsDTOList[0].questionOfGroupDTOS.map( (question, q)=>{
                            return <div className='historical-info-cita' key={`question${q}`}>
                                    <span>{question?.label}</span>
                                    <div>{question?.note}</div>
                            </div>
                        })
                        :<>
                            <div className='historical-info-cita'>
                                    <span> {t('diagnostico')} </span>
                                    <div></div>
                            </div>
                            <div className='historical-info-cita'>
                                    <span> {t('recomendacion_medica')} </span>
                                    <div></div>
                            </div>
                            <div className='historical-info-cita'>
                                    <span> {t('formulacion')} </span>
                                    <div></div>
                            </div>
                            <div className='historical-info-cita'>
                                    <span> {t('ficha_epidemiologica')} </span>
                                    <div></div>
                            </div>
                            <div className='historical-info-cita'>
                                    <span> {t('incapacidad')} </span>
                                    <div></div>
                            </div>
                        </>
                    }
                </div>
            </Card>
        </>
    )
}

export default withTranslation()(CardHistorialCitas)
